export const SERVICE_ID = 2;

export enum STATE {
  inactive,
  active,
}

export enum STATUS_REQUEST {
  created,
  approvedSendingData,
  pendingSend,
  sentRequest,
  approvedIncomingData,
  resolved,
  approvedReturnResponse,
  pendingReturn,
  receivedResponse,
  approvedIncomingResponse,
  success,
  failed,
  rejected,
  timeOut,
}

export enum REQUEST_TYPE {
  normal, // 0: Other request
  getData, // 1: Request to get data from another system
  saveData, // 2: Request another system to save data
}

export enum SOURCE_ID {
  internal,
  external,
}

export const ATTACHMENT_TYPES = {
  image: "image",
};

export enum ROLE {
  admin,
  user,
}

export const RESPONSE_TYPE = {
  identification: 1,
  sailor: 2,
  ship: 3,
} as const;

export enum SERVER_TYPE {
  SGW,
  DATALAKE,
  GST,
  SAILOR_ID,
}

export const SOURCE_TYPE = {
  GST: { id: 0, name: "Giám sát tàu" },
  C06: { id: 1, name: "Cục C06" },
  CHH: { id: 2, name: "Cục Hàng Hải" },
  BQP: { id: 3, name: "Biên Phòng" },
  CTS: { id: 4, name: "Cục Thủy Sản" },
  CHQ: { id: 5, name: "Cục Hải Quan" },
  DK: { id: 6, name: "Cục Đăng Kiểm" },
  CSB: { id: 7, name: "Cảnh sát biển" },
  ThuyenVien: { id: 8, name: "Thuyền viên ID" },
};
